class MenuMobile extends Menu {

  constructor(element, options = {}) {
    const settings = {
      menuClassName: 'menu-mobile',
      ...options
    }

    super(element, settings);
  }

  initElements() {
    super.initElements();
    this.$backButton = this.$element.querySelector(`.${this.$menuClassName}__back-button`);
  }

  addEventListeners() {
    super.addEventListeners();

    this.$items.forEach(item => {
      if (item.classList.contains(`${MenuMobile.MENU_ITEM_CLASS}--with-children`)) {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          this.showSubmenu();
          this.setActiveAlias(this.submenuVisibleLevel, item.dataset.alias)
        });
      }
    });

    this.$backButton.addEventListener('click', () => {
      this.hideSubmenu();
    });

    window.addEventListener('catalog-tab-click', () => {
      if (!this.$opened) {
        this.opened = true;
      }
    });

    window.addEventListener('active-tab-click', () => {
      if (this.$opened) {
        this.opened = false;
      }
    });
  }

  hideSubmenu() {
    this.submenuVisibleLevel -= 1;
  }

  updateClassName() {
    const classNameArray = [
      this.$menuClassName
    ];

    if (this.$opened) {
      classNameArray.push(`${this.$menuClassName}--opened`);
    }

    this.$element.className = classNameArray.join(' ');
  }

  updateSections() {
    super.updateSections();
    this.updateSubmenus();
  }

  updateSubmenus() {
    this.$submenus.forEach((submenu) => {
      const level = Number(submenu.dataset.level);

      submenu.classList.toggle(`${this.$menuClassName}__level--visible`, level === this.$submenuVisibleLevel);
      submenu.classList.toggle(`${this.$menuClassName}__level--previous`, level < this.$submenuVisibleLevel);
      submenu.classList.toggle(`${this.$menuClassName}__level--next`, level > this.$submenuVisibleLevel);
    });

  }

  get opened() {
    return this.$opened;
  }

  set opened(value) {
    if (this.$opened === value) {
      return;
    }

    this.$opened = value;

    this.updateClassName();

    const toggleEventName = this.$opened ? 'mobile-menu-open' : 'mobile-menu-close';
    const toggleEvent = new CustomEvent(toggleEventName);

    window.dispatchEvent(toggleEvent);
  }

}

const menuMobile = new MenuMobile(document.querySelector('.menu-mobile'));